var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49242 16.0724C9.78747 16.3146 10.2125 16.3146 10.5076 16.0724C13.6321 13.5077 15.6915 11.7238 16.9629 10.2208C18.2722 8.67292 18.8 7.35925 18.8 5.75811C18.8 3.24978 16.7521 1.2 14.2441 1.2C12.0143 1.2 10.7913 2.55423 10 3.45836C9.20869 2.55423 7.98573 1.2 5.75587 1.2C3.24786 1.2 1.2 3.24977 1.2 5.75811C1.2 7.35925 1.72775 8.67292 3.0371 10.2208C4.30845 11.7238 6.36794 13.5077 9.49242 16.0724Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.a7b36010cee341a2d40983cf6c73bd26.svg";
export { ForwardRef as ReactComponent };